import React from 'react';

import TestimonialCard from '@core/components/contentparser/sections/Testimonials/TestimonialCard/TestimonialCard';
import ScrollAnimation from 'react-animate-on-scroll';
import TrustPilot from '@core/components/contentparser/sections/Testimonials/trustpilot/TrustPilot';

import classes from './Testimonials.module.scss';
import ActionButton from '@core/components/actionbutton/ActionButton';



const Testimonials = ({ section }) => {
    const [expanded, setExpanded] = React.useState(false);

    const handleLoadMore = () => {
        setExpanded(true);
    };

    return (
        <div className='container' style={{ position: 'relative' }}>
            <div
                className={classes['wrapper']}
                style={{
                    padding: '0 20px',
                    maxHeight: expanded ? 'none' : '700px',
                    overflowY: expanded ? 'visible' : 'hidden',
                    transition: 'max-height 1s ease',
                    position: 'relative'
                }}
            >
                <ScrollAnimation animateIn="fadeInUp" duration={1}>
                    <h3>Success Stories from Our Learners</h3>
                    <h5>
                        Discover inspiring stories of success from our community. See how learners are advancing
                        their careers and achieving their professional aspirations in the pharmaceutical and biotech
                        industries.
                    </h5>
                    <TrustPilot />
                </ScrollAnimation>
                <div className="row d-none d-xl-flex">
                    <div className="col-xl-4 ">
                        <TestimonialCard data={section.results[0]} />
                        <TestimonialCard data={section.results[3]} />
                        <TestimonialCard data={section.results[6]} />
                    </div>
                    <div className="col-xl-4 ">
                        <TestimonialCard data={section.results[1]} />
                        <TestimonialCard data={section.results[4]} />
                        <TestimonialCard data={section.results[7]} />
                    </div>
                    <div className="col-xl-4 ">
                        <TestimonialCard data={section.results[2]} />
                        <TestimonialCard data={section.results[5]} />
                        <TestimonialCard data={section.results[8]} />
                    </div>
                </div>
                <div className="row d-none d-lg-flex d-xl-none">
                    <div className="col-lg-6 ">
                        <TestimonialCard data={section.results[0]} />
                        <TestimonialCard data={section.results[2]} />
                        <TestimonialCard data={section.results[4]} />
                        <TestimonialCard data={section.results[6]} />
                        <TestimonialCard data={section.results[8]} />
                    </div>
                    <div className="col-lg-6 ">
                        <TestimonialCard data={section.results[1]} />
                        <TestimonialCard data={section.results[3]} />
                        <TestimonialCard data={section.results[5]} />
                        <TestimonialCard data={section.results[7]} />
                    </div>
                </div>
                <div className="row d-flex d-lg-none">
                    <div className="col-lg-12">
                        <TestimonialCard data={section.results[0]} />
                        <TestimonialCard data={section.results[1]} />
                        <TestimonialCard data={section.results[2]} />
                    </div>
                </div>
                {!expanded && (
                    <div
                        style={{
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            bottom: 0,
                            height: '200px',
                            background: 'linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.95) 100%)',
                            pointerEvents: 'none',
                            transition: 'opacity 0.5s',
                            zIndex: 2
                        }}
                    />
                )}
            </div>
            {!expanded && (
                <div className={classes['button-wrapper']}>
                    <ActionButton kind='secondary' onClick={handleLoadMore}>
                        Load More
                    </ActionButton>
                </div>
            )}
        </div>
    );
};

export default Testimonials;